"use client";

import type React from "react";
import { useId } from "react";

import { cn } from "@/lib/utils";

export type HelpSearchProps = {
  className?: string;
  value: string;
  onChange: (value: string) => void;
};

export function HelpSearch({
  className,
  value,
  onChange,
}: HelpSearchProps): React.ReactElement {
  const id = useId();

  return (
    <div className={cn("space-y-1.5", className)}>
      <label
        className="text-muted-foreground text-xs font-medium"
        htmlFor={id}
      >
        搜索本页
      </label>
      <input
        className="border-input bg-background focus-visible:border-ring focus-visible:ring-ring/50 h-9 w-full rounded-md border px-3 text-sm shadow-xs outline-none transition-[color,box-shadow] focus-visible:ring-[3px]"
        id={id}
        type="search"
        autoComplete="off"
        placeholder="输入关键词过滤章节…"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
}
